import { V as VisibilityManager } from './index2.js';
import './index3.js';
import { RocheAccordionTabs } from './roche-accordion-tabs.js';
import { RocheAccordionTabsItem } from './roche-accordion-tabs-item.js';
import { RocheAddToCalendar } from './roche-add-to-calendar.js';
import { RocheAnchor } from './roche-anchor.js';
import { RocheAnimatedWords } from './roche-animated-words.js';
import { RocheAnimationManager } from './roche-animation-manager.js';
import { RocheAvatar } from './roche-avatar.js';
import { RocheBackToBranch } from './roche-back-to-branch.js';
import { RocheBreadcrumbs } from './roche-breadcrumbs.js';
import { RocheButton } from './roche-button.js';
import { RocheColumn } from './roche-column.js';
import { RocheColumns } from './roche-columns.js';
import { RocheContactPerson } from './roche-contact-person.js';
import { RocheContainer } from './roche-container.js';
import { RocheDate } from './roche-date.js';
import { RocheDropdown } from './roche-dropdown.js';
import { RocheEditorAlert } from './roche-editor-alert.js';
import { RocheEmergencyBanner } from './roche-emergency-banner.js';
import { RocheEmptyState } from './roche-empty-state.js';
import { RocheFilters } from './roche-filters.js';
import { RocheFooter } from './roche-footer.js';
import { RocheForm } from './roche-form.js';
import { RocheFoucPreventer } from './roche-fouc-preventer.js';
import { RocheGenericLink } from './roche-generic-link.js';
import { RocheGrid } from './roche-grid.js';
import { RocheHeader } from './roche-header.js';
import { RocheHeadline } from './roche-headline.js';
import { RocheHeroTeaser } from './roche-hero-teaser.js';
import { RocheHighlightBox } from './roche-highlight-box.js';
import { RocheHorizontalCenter } from './roche-horizontal-center.js';
import { RocheIcon } from './roche-icon.js';
import { RocheImage } from './roche-image.js';
import { RocheInput } from './roche-input.js';
import { RocheLanguageSwitch } from './roche-language-switch.js';
import { RocheLeadText } from './roche-lead-text.js';
import { RocheLinkList } from './roche-link-list.js';
import { RocheList } from './roche-list.js';
import { RocheListSearch } from './roche-list-search.js';
import { RocheListTextItem } from './roche-list-text-item.js';
import { RocheLoadingSpinner } from './roche-loading-spinner.js';
import { RocheLogin } from './roche-login.js';
import { RocheMagnet } from './roche-magnet.js';
import { RocheMarketo } from './roche-marketo.js';
import { RocheMessage } from './roche-message.js';
import { RocheModal } from './roche-modal.js';
import { RocheNavigation } from './roche-navigation.js';
import { RocheNavigationMobile } from './roche-navigation-mobile.js';
import { RocheOffcanvasPanel } from './roche-offcanvas-panel.js';
import { RocheOffcanvasTrigger } from './roche-offcanvas-trigger.js';
import { RocheOnClickNotice } from './roche-on-click-notice.js';
import { RocheOnLoadNotice } from './roche-on-load-notice.js';
import { RocheOverline } from './roche-overline.js';
import { RochePagination } from './roche-pagination.js';
import { RochePaginationButton } from './roche-pagination-button.js';
import { RochePaginationContainer } from './roche-pagination-container.js';
import { RochePipelineCaption } from './roche-pipeline-caption.js';
import { RochePipelineChangesRow } from './roche-pipeline-changes-row.js';
import { RochePipelineChangesTable } from './roche-pipeline-changes-table.js';
import { RochePipelineDiagnostics } from './roche-pipeline-diagnostics.js';
import { RochePipelineDiagnosticsRow } from './roche-pipeline-diagnostics-row.js';
import { RochePipelineTable } from './roche-pipeline-table.js';
import { RochePipelineTableRow } from './roche-pipeline-table-row.js';
import { RochePopularSearch } from './roche-popular-search.js';
import { RochePublishedDate } from './roche-published-date.js';
import { RocheQuote } from './roche-quote.js';
import { RocheRegistration } from './roche-registration.js';
import { RocheResponsiveTable } from './roche-responsive-table.js';
import { RocheRichtext } from './roche-richtext.js';
import { RocheScaleOnScroll } from './roche-scale-on-scroll.js';
import { RocheSearch } from './roche-search.js';
import { RocheSearchInput } from './roche-search-input.js';
import { RocheSearchListContainer } from './roche-search-list-container.js';
import { RocheSelect } from './roche-select.js';
import { RocheSideBySide } from './roche-side-by-side.js';
import { RocheSingleSignIn } from './roche-single-sign-in.js';
import { RocheSlider } from './roche-slider.js';
import { RocheSocialMedia } from './roche-social-media.js';
import { RocheStageHome } from './roche-stage-home.js';
import { RocheStageHomeTeaser } from './roche-stage-home-teaser.js';
import { RocheStagingHero } from './roche-staging-hero.js';
import { RocheStockPrice } from './roche-stock-price.js';
import { RocheStoryStagingHero } from './roche-story-staging-hero.js';
import { RocheStoryTeaser } from './roche-story-teaser.js';
import { RocheSubline } from './roche-subline.js';
import { RocheTabNavButton } from './roche-tab-nav-button.js';
import { RocheTabNavContainer } from './roche-tab-nav-container.js';
import { RocheTable } from './roche-table.js';
import { RocheTableSortHeader } from './roche-table-sort-header.js';
import { RocheTag } from './roche-tag.js';
import { RocheTeaser } from './roche-teaser.js';
import { RocheTeaserWall } from './roche-teaser-wall.js';
import { RocheTextImage } from './roche-text-image.js';
import { RocheTextLink } from './roche-text-link.js';
import { RocheTooltip } from './roche-tooltip.js';
import { RocheVideoPlayer } from './roche-video-player.js';
export { getAssetPath, setAssetPath, setNonce, setPlatformOptions } from '@stencil/core/internal/client';

// Prerender detection
window.isPrerender = !window.Map;
if (window.isPrerender) {
    /**
     * @brightcove/player-loader uses Map.
     * On server side rendering context Map won't be defined,
     * hence we need to define it as a constructor
     */
    window.Map = class {
        // Methods need to be created for @brightcove/player-loader to function properly
        /* eslint-disable class-methods-use-this,@typescript-eslint/no-empty-function */
        set() { }
        has() { }
        get() { }
        clear() { }
        forEach() { }
    };
}
else {
    VisibilityManager.listen();
}

const defineCustomElements = (opts) => {
    if (typeof customElements !== 'undefined') {
        [
            RocheAccordionTabs,
            RocheAccordionTabsItem,
            RocheAddToCalendar,
            RocheAnchor,
            RocheAnimatedWords,
            RocheAnimationManager,
            RocheAvatar,
            RocheBackToBranch,
            RocheBreadcrumbs,
            RocheButton,
            RocheColumn,
            RocheColumns,
            RocheContactPerson,
            RocheContainer,
            RocheDate,
            RocheDropdown,
            RocheEditorAlert,
            RocheEmergencyBanner,
            RocheEmptyState,
            RocheFilters,
            RocheFooter,
            RocheForm,
            RocheFoucPreventer,
            RocheGenericLink,
            RocheGrid,
            RocheHeader,
            RocheHeadline,
            RocheHeroTeaser,
            RocheHighlightBox,
            RocheHorizontalCenter,
            RocheIcon,
            RocheImage,
            RocheInput,
            RocheLanguageSwitch,
            RocheLeadText,
            RocheLinkList,
            RocheList,
            RocheListSearch,
            RocheListTextItem,
            RocheLoadingSpinner,
            RocheLogin,
            RocheMagnet,
            RocheMarketo,
            RocheMessage,
            RocheModal,
            RocheNavigation,
            RocheNavigationMobile,
            RocheOffcanvasPanel,
            RocheOffcanvasTrigger,
            RocheOnClickNotice,
            RocheOnLoadNotice,
            RocheOverline,
            RochePagination,
            RochePaginationButton,
            RochePaginationContainer,
            RochePipelineCaption,
            RochePipelineChangesRow,
            RochePipelineChangesTable,
            RochePipelineDiagnostics,
            RochePipelineDiagnosticsRow,
            RochePipelineTable,
            RochePipelineTableRow,
            RochePopularSearch,
            RochePublishedDate,
            RocheQuote,
            RocheRegistration,
            RocheResponsiveTable,
            RocheRichtext,
            RocheScaleOnScroll,
            RocheSearch,
            RocheSearchInput,
            RocheSearchListContainer,
            RocheSelect,
            RocheSideBySide,
            RocheSingleSignIn,
            RocheSlider,
            RocheSocialMedia,
            RocheStageHome,
            RocheStageHomeTeaser,
            RocheStagingHero,
            RocheStockPrice,
            RocheStoryStagingHero,
            RocheStoryTeaser,
            RocheSubline,
            RocheTabNavButton,
            RocheTabNavContainer,
            RocheTable,
            RocheTableSortHeader,
            RocheTag,
            RocheTeaser,
            RocheTeaserWall,
            RocheTextImage,
            RocheTextLink,
            RocheTooltip,
            RocheVideoPlayer,
        ].forEach(cmp => {
            if (!customElements.get(cmp.is)) {
                customElements.define(cmp.is, cmp, opts);
            }
        });
    }
};

export { defineCustomElements };

//# sourceMappingURL=index.js.map